module.exports = __webpack_public_path__ + "media/blog/email-form-image-7eb5e308.png";